

const US_BBOXES = Object.freeze([
  { minLat: 24.0, maxLat: 49.5, minLng: -125.0, maxLng: -66.0 },  // continental
  { minLat: 51.0, maxLat: 71.5, minLng: -180.0, maxLng: -129.0 }, // Alaska
  { minLat: 18.5, maxLat: 22.5, minLng: -161.0, maxLng: -154.0 }, // Hawaii
]);

/**
 * @param {Array<number> | null | undefined} coordinates  `[lng, lat]`
 * @returns {'mi' | 'km'}
 */
export function getDistanceUnitForCoordinates(coordinates) {
  if (!Array.isArray(coordinates) || coordinates.length !== 2) return 'km';
  const [lng, lat] = coordinates;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return 'km';

  for (const box of US_BBOXES) {
    if (
      lat >= box.minLat &&
      lat <= box.maxLat &&
      lng >= box.minLng &&
      lng <= box.maxLng
    ) {
      return 'mi';
    }
  }
  return 'km';
}
